import React, { Fragment } from 'react'
import { useCatalogsDiscount } from '../../hooks/specialDiscounts/useCatalogsDiscount'
import { Button, Card, Badge, Col, Container, CardBody, Row, CardHeader, Label, Input, Table, CardFooter, ButtonGroup, Form } from 'reactstrap';
import { TableStriped } from '../../components/tables/TableStriped';
import { ModalVisibleDiscount } from '../../components/specialDiscounts/ModalVisibleDiscount';
import { ModalCrudDiscount } from '../../components/specialDiscounts/ModalCrudDiscount';
import { AlertDataTable } from '../../components/tableDataTable/AlertDataTable';
import { TitleDataTable } from '../../components/tableDataTable/TitleDataTable';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';


export const IndexCatalogsDiscounts = () => {

    const {
        listDiscounts,

        // * PAGINATION
        totalPageCount, currentPage, nextPage, previousPage, goToPage, handleSearchDiscount,

        // * CRUD TABLE
        handleCreate, handleUpdate, handleDelete, toggle, method, modal,
        name, description, percentage, active, handleInputChange,
        saveCreateDiscounts, saveUpdateDiscount, saveDeleteDiscount, loading,

        // * MODAL STATUS
        toggleStatus, modalStatus, tittleDiscount, closeDialog, modalAlert, showDeleteAlert,
        closeDeleteAlert, handleExcelCatalogDiscounts, setLoadingExcel, loadingExcel,
        handleClearDiscount, handleSearch, searchDiscount

    } = useCatalogsDiscount()

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const actions = (rowData) => {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <Button
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_preloaded_discount)}
                    title="Editar"
                    className="btnTableAction"
                >
                    <i className="fa fa-edit iconTableAction"></i>
                </Button>


                <button
                    onClick={() => handleDelete(rowData.id_preloaded_discount)}
                    title="Eliminar"
                    className="btnTableAction"
                    style={{
                        backgroundColor: "#bf0d0d"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </button>
            </div>
        );
    };


    return (
        <>
            <Fragment>
                <Container fluid={true} className='container-global-zoom'>
                    <Row>
                        <Col sm="12">
                            <Card>
                                <CardBody className='p-3'>
                                      <TitleDataTable
                                        titleTable="Listado de descuentos"
                                        buttonActions={handleExcelCatalogDiscounts}
                                        titleButton="Listado de descuentos"
                                        isDisbled={loadingExcel}
                                        loadingIsDisabled={loadingExcel}
                                        titleCreate="Crear sitio"
                                        buttonActionsCreate={handleCreate}
                                        actionInput={handleSearch}
                                        valueFilter={searchDiscount}
                                        filterLocalStorage={true}
                                        cleanFilterLocalStorage={handleClearDiscount}
                                    />

                                    <div className="table-responsive">
                                        <DataTable
                                            value={listDiscounts}
                                            paginator
                                            rows={15}
                                            responsiveLayout="scroll"
                                            rowsPerPageOptions={[15, 50, 100]} 
                                            className="data-table p-datatable-striped p-datatable-sm"
                                            emptyMessage={
                                                <div className="text-center">
                                                    <img
                                                        src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                        style={{ width: "32%" }}
                                                        alt="Sin resultados"
                                                    />
                                                    <br />
                                                    <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                        No se encontraron resultados.
                                                    </p>
                                                </div>
                                            }
                                        >
                                            <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                            <Column field="name" header="Nombre de Descuento" headerStyle={headerStyle} style={cellStyle} />
                                            <Column field="description" header="Descripción" headerStyle={headerStyle} style={cellStyle} />
                                            <Column field="percentage" header="Porcentaje" headerStyle={headerStyle} style={cellStyle} />
                                            <Column
                                                header="Activo"
                                                headerStyle={headerStyle}
                                                style={cellStyle}
                                                body={(rowData) => {

                                                    const isActive = rowData.active;

                                                    return (
                                                        <span
                                                            style={{
                                                                padding: "4px 10px",
                                                                borderRadius: "12px",
                                                                fontSize: "12px",
                                                                fontWeight: "600",
                                                                color: "#fff",
                                                                background: isActive ? "#4CAF50" : "#F44336"
                                                            }}
                                                        >
                                                            {isActive ? "Activo" : "Inactivo"}
                                                        </span>
                                                    );
                                                }}
                                            />
                                            <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
                                        </DataTable>
                                    </div>
                                </CardBody>
                            </Card>

                            {showDeleteAlert && (
                                <AlertDataTable
                                    titleAlert="Eliminar descuentos"
                                    visibleAlert={modalAlert}
                                    onHideAlert={closeDeleteAlert}
                                    sizeAlert="medium-dialog delete-method"
                                    messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar el descuento?"
                                    alert1={true}
                                    titleAlert1={name}
                                    buttonAcept
                                    titleNotLoading="Eliminar"
                                    titleDanger="Cancelar"
                                    actionAcept={saveDeleteDiscount}
                                />

                            )}
                        </Col>
                    </Row>
                </Container>


                <ModalVisibleDiscount
                    {
                    ...{ toggleStatus, modalStatus, tittleDiscount, loading }
                    }
                />
                <ModalCrudDiscount
                    {
                    ...{
                        closeDialog, method, modal, name, description, percentage, active, handleInputChange, saveCreateDiscounts, saveUpdateDiscount, saveDeleteDiscount, tittleDiscount, loading
                    }
                    }
                />
            </Fragment>
        </>
    )

}
